module.exports = __webpack_public_path__ + "img/need-help-icon.5f82715a.png";